const getHexLuminance = (hex) => {
  const r = parseInt(hex.substr(1, 2), 16)
  const g = parseInt(hex.substr(3, 2), 16)
  const b = parseInt(hex.substr(5, 2), 16)

  let luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255
  luminance = Math.round((luminance + Number.EPSILON) * 100) / 100

  return luminance
}

export default getHexLuminance
